export const GMAT_SET_FEEDBACK = "GMAT_SET_FEEDBACK";
export const GMAT_SET_START_ERROR = "GMAT_SET_START_ERROR";
